<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" *ngIf="!!this.items.length">
    <ng-container *ngIf="items[currentIndex].item_type_value?.toLowerCase().includes('text')">
        <ng-container
            *ngTemplateOutlet="mediaViewItem; context: { item: items[currentIndex], media: items[currentIndex].name }"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="!items[currentIndex].item_type_value?.toLowerCase().includes('text')">
        <ng-container
            *ngTemplateOutlet="
                mediaViewItem;
                context: { item: items[currentIndex], media: items[currentIndex].media$ | async }
            "
        ></ng-container>
    </ng-container>
    <div class="next-btn-top w-100" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <ng-container *ngIf="materialWithOptions">
            <ng-container *ngIf="currentMedia.mediaType == MediaType.PDF">
                <ng-container *ngIf="mediaView" [ngTemplateOutlet]="pdfNav"></ng-container>
                <button
                    (click)="openInNewTab()"
                    matTooltip="Open in a new tab"
                    i18n-matTooltip="@@openInAnewTab"
                    mat-icon-button
                    class="next-btn"
                    color="primary"
                >
                    <mat-icon>launch</mat-icon>
                </button>
            </ng-container>
            <ng-container
                *ngIf="currentMedia.mediaType == MediaType.VIDEO || currentMedia.mediaType == MediaType.AUDIO"
            >
                <ng-container *ngIf="mediaView && mediaView.player" [ngTemplateOutlet]="playerControls"></ng-container>
            </ng-container>
            <ng-container *ngIf="currentMedia.mediaType == MediaType.URL || currentMedia.mediaType == MediaType.LINK">
                <button
                    (click)="openInNewTab()"
                    matTooltip="Open in a new tab"
                    i18n-matTooltip="@@openInAnewTab"
                    mat-icon-button
                    class="next-btn"
                    color="primary"
                >
                    <mat-icon>launch</mat-icon>
                </button>
            </ng-container>
        </ng-container>
        <ng-container
            *ngIf="items.length > 1"
            [ngTemplateOutlet]="materialItemsNav"
            [ngTemplateOutletContext]="{ items: items }"
        ></ng-container>
    </div>
</div>

<ng-template #loading>
    <div class="mt-2 mb-1" fxLayout="row" fxLayoutAlign="center center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #pdfNav>
    <button
        mat-icon-button
        (click)="mediaView.firstPage()"
        [disabled]="mediaView.page === 1"
        type="button"
        matTooltip="First page"
        i18n-matTooltip="@@firstPage"
    >
        <mat-icon>first_page</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="mediaView.previousPage()"
        [disabled]="mediaView.page === 1"
        type="button"
        matTooltip="Previous"
        i18n-matTooltip="@@previous"
    >
        <mat-icon>navigate_before</mat-icon>
    </button>

    <span class="page-count">{{ mediaView.page }} / {{ mediaView.totalPages }}</span>

    <button
        mat-icon-button
        (click)="mediaView.nextPage()"
        [disabled]="mediaView.page === mediaView.totalPages"
        type="button"
        matTooltip="Next"
        i18n-matTooltip="@@next"
    >
        <mat-icon>navigate_next</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="mediaView.lastPage()"
        [disabled]="mediaView.page === mediaView.totalPages"
        type="button"
        matTooltip="Last page"
        i18n-matTooltip="@@lastPage"
    >
        <mat-icon>last_page</mat-icon>
    </button>
</ng-template>

<ng-template #playerControls>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.seekTime(10, false)"
        mat-icon-button
        class="next-btn mr-0"
        color="primary"
        matTooltip="Backward 10 seconds"
        i18n-matTooltip="@@backward"
    >
        <mat-icon>replay_10</mat-icon>
    </button>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.seekTime(10, true)"
        mat-icon-button
        class="next-btn"
        color="primary"
        matTooltip="Forward 10 seconds"
        i18n-matTooltip="@@forward10"
    >
        <mat-icon>forward_10</mat-icon>
    </button>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.pause()"
        mat-raised-button
        class="next-btn"
        color="primary"
    >
        <mat-icon>pause</mat-icon>
        <span i18n="@@pause">Pause</span>
    </button>
    <button
        *ngIf="!mediaView.player.isPlaying"
        (click)="mediaView.player.play()"
        mat-raised-button
        class="next-btn"
        color="primary"
    >
        <mat-icon>play_circle</mat-icon>
        <span i18n="@@play">Play</span>
    </button>
</ng-template>
<ng-template #materialItemsNav let-items="items">
    <ng-container *ngIf="items.length > 1">
        <button
            mat-icon-button
            (click)="currentIndex = 0"
            [disabled]="currentIndex == 0"
            type="button"
            matTooltip="First item"
            i18n-matTooltip="@@firstItem"
        >
            <mat-icon>first_page</mat-icon>
        </button>
        <button
            mat-icon-button
            [disabled]="currentIndex === 0"
            (click)="currentIndex = currentIndex - 1"
            type="button"
            matTooltip="Previous"
            i18n-matTooltip="@@previous"
        >
            <mat-icon>navigate_before</mat-icon>
        </button>

        <span class="page-count">{{ currentIndex + 1 }} / {{ items.length }}</span>

        <button
            mat-icon-button
            [disabled]="currentIndex === items.length - 1"
            (click)="currentIndex = currentIndex + 1"
            type="button"
            matTooltip="Next"
            i18n-matTooltip="@@next"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="currentIndex = items.length - 1"
            [disabled]="currentIndex + 1 == items.length"
            type="button"
            matTooltip="Last item"
            i18n-matTooltip="@@lastItem"
        >
            <mat-icon>last_page</mat-icon>
        </button>
    </ng-container>
</ng-template>
<ng-template #mediaViewItem let-item="item" let-media="media">
    <app-player-media-view
        class="media"
        [ignoreThumbnail]="true"
        [resourceItemTypeValue]="item.item_type_value"
        [media_id]="media"
        [canDownlaodMedia]="item.can_download"
        [displayName]="false"
        (nextBtnClickedInPDF)="nextBtnClickedInPDF = true"
        (onMediaUpdated)="$event && onMediaUpdated($event)"
    >
    </app-player-media-view>
</ng-template>
